import { ChangeDetectorRef, Component, Input, OnInit, HostListener, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { filter } from 'rxjs/operators';
import { ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { TipoConteudo } from 'src/app/model/arquivo.model';
import { ProtocoloArquivo, StatusProtocolo, STATUS_PROTOCOLO, TIPO_PROTOCOLO } from 'src/app/model/protocolo-arquivo.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { ProtocoloArquivoService } from 'src/app/shared/services/protocolo-arquivo.service';
import { AtualizacaoInfoRiscoService } from 'src/app/features/prestacao-informacoes/atualizacao-informacoes-risco/atualizacao-info-risco.service';
import {JanelaAtualizacaoInformacoesRisco } from 'src/app/model/atualizacao-info-risco.model';




@Component({
    selector: 'app-protocolo-pesquisa',
    templateUrl: './protocolo-pesquisa.component.html',
    styleUrls: ['./protocolo-pesquisa.component.scss'],
    standalone: false
})
export class ProtocoloPesquisaComponent implements OnInit {

    @Input() titulo: string;
    @Input() routerLinkEnvioLote: string; // ex.: '['/operacoes/cadastro/lote']
    @Input() routerLinkEnvioLote2: string;
    @Input() routerLinkPesquisaLote: string;
    @Input() routerLinkCadastro: string;
    @Input() tooltipBotaoEnvio: string;
    @Input() textoBotaoEnvio: string;
    @Input() textoBotaoEnvio2: string;
    @Input() textoBotaoCadastro: string;
    @Input() tiposConteudo: TipoConteudo[];
    @Input() incluirCampoJanelaEnvio = false; // inclui nos filtros e na tabela de resultados
    @Input() formatoArquivo: string;
    @Input() mostrarCampoModoEnvio: boolean = true;

    pesquisaForm: UntypedFormGroup;
    cnpjUsuario: string;
    cnpjSelecionado: string;
    statusSelecionado: StatusProtocolo;

    pesquisado: boolean; // usado no html
    esconderPesquisa: boolean = true;

    agentesFinanceiros: AgenteFinanceiro[] = [];
    valoresStatusProtocolo = STATUS_PROTOCOLO;
    podeEscolherAgente = false;
    podeEnviarLote = false;
    podeEnviarLoteAposJanela = false;
    protocolos: ProtocoloArquivo[];
    tiposProtocolo = TIPO_PROTOCOLO;
    public exibirComboTipoArquivo: Boolean = false;
    private rotasPermitidas: string[] = ['/operacoes/lote', '/atualizacao-informacoes/lote'];
    private atributosPaginacaoComponenteListagem: EntityPagedResult<ProtocoloArquivo>;
    private opcoesPaginacao: number[];
    private totalObjetosRetornados: number;
    private permitirForajanela:boolean = false
    private janela:JanelaAtualizacaoInformacoesRisco;
   
    private dataCorrente: Date;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private permissaoService: PermissaoService,
        private loadingService: BnLoadingService,
        private service: ProtocoloArquivoService,
        private agenteService: AgenteFinanceiroService,
        private bnUsuarioService: BnUsuarioService,
        private atualizacaoInfoRiscoService: AtualizacaoInfoRiscoService,
        private cdref: ChangeDetectorRef,
        private router: Router
    ) {
        //TODO jgoes melhorar essa verificaçao.
        this.exibirComboTipoArquivo = this.rotasPermitidas.includes(this.router.url);
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
        this.buscar(false, true)
    }

    ngOnInit(): void {

        //console.log(this.router.getCurrentNavigation().extractedUrl);
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
            this.podeEnviarLote = resp && resp[ROLE_AGENTE_ENVIO];
        });

        this.bnUsuarioService.usuario$.pipe(
            filter(usuario => !!usuario)
        ).subscribe(usuario => {
            this.cnpjUsuario = usuario.cnpj ? usuario.cnpj : 'BNDES';
        });

        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoComponenteListagem = {
            page: 1,
            pageSize: this.opcoesPaginacao[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };

        this.tiposProtocolo = TIPO_PROTOCOLO.filter((t) => this.tiposConteudo.includes(<TipoConteudo>t.codigo));

        this.pesquisado = undefined;
         this.getPermitirForaJanela();

        this.construirFormulario();
        this.buscarAgentesFinanceiros();
    }


    private getPermitirForaJanela() {
        this.service.getJanelaPermitirEnvio({ cnpjAgente: this.cnpjUsuario, tiposProtocolos: this.tiposConteudo.join('&') })
            .subscribe(foraJanela => {
                this.permitirForajanela = foraJanela;
            });
    }


    private construirFormulario() {
        this.pesquisaForm = this.formBuilder.group({
            agenteFinanceiro: [{value: '', disabled: !this.podeEscolherAgente}],
            statusProtocolo: [''],
            modoEnvio: [''], // efetivo ou apenas validacao
            dataEnvioInicial: [''],
            dataEnvioFinal: [''],
            idProtocoloNegocio: [''],
            idSolicitacaoApiExt: [''],
            nomeJanelaEnvio: [Utils.dataCorrente(), ''], // preenche o default com a janela do mes corrente
            tipoProtocolo: null,
        });
        this.service.getTimeStampISO().subscribe((dataAtualBackend: any) => {
            //console.debug(`dataAtualBackend: ${JSON.stringify(dataAtualBackend)}`);
            this.dataCorrente = dataAtualBackend;
            this.pesquisaForm.get('nomeJanelaEnvio').setValue(Utils.dataFromISO(dataAtualBackend.nowDateISO));
        });
    }

    private buscarAgentesFinanceiros() {
        this.agenteService.getAgentesFinanceirosNestaModalidade(true)
            .subscribe(agentes => {
                this.agentesFinanceiros = agentes;
            });
    }

    podePesquisar(): boolean {
        return true;
        /*
         if (this.podeEscolherAgente) {
             return this.agentesFinanceiros?.length && this.pesquisaForm.get('agenteFinanceiro').value;
         } else {
             return this.cnpjUsuario !== undefined;
         }*/
    }

    mudancaPagina(novaPagina: EntityPagedResult<ProtocoloArquivo>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.buscar(false, false);
    }

    aposExcluirProtocolo() {
        this.buscar(false, true);
    }

    compararPorId(item1: string, item2: string): boolean {
        return (item1 && item2) ? (item1 === item2) : (!item1 && !item2);
    }

    buscar(paginaVazia: boolean, voltarPagina1: boolean) {
        this.loadingService.bloqueiaTela();
        this.esconderPesquisa = true;


        const nomeAgenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;

        if (!nomeAgenteFinanceiro && !this.cnpjUsuario) {
            return;
        }

        let agenteFinanceiro;
        if (this.podeEscolherAgente) {
            agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.nome === nomeAgenteFinanceiro)[0];
        } else {
            agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
        }

        const tipoProtocolo = this.pesquisaForm.get('tipoProtocolo').value;

        const labelStatusProtocolo = this.pesquisaForm.get('statusProtocolo')?.value;
        const statusProtocolo = STATUS_PROTOCOLO.find(status => status.label === labelStatusProtocolo);

        const modoEnvio = this.pesquisaForm.get('modoEnvio')?.value;
        const apenasValidacao = (modoEnvio === 'Todos' || modoEnvio === '') ?
            undefined : (modoEnvio === 'Apenas validação');

        const dataEnvioInicial: Date = this.pesquisaForm.get('dataEnvioInicial')?.value;
        const dataEnvioFinal: Date = this.pesquisaForm.get('dataEnvioFinal')?.value;

        const nomeJanelaEnvio: Date = this.pesquisaForm.get('nomeJanelaEnvio')?.value;

        const idProtocoloNegocio: string = this.pesquisaForm.get('idProtocoloNegocio')?.value;

        const idSolicitacaoApiExt: number = this.pesquisaForm.get('idSolicitacaoApiExt')?.value;

        /* preenchimento dos filtros */
        const params: any = {};

        if (agenteFinanceiro) {
            params.cnpjAgente = agenteFinanceiro.cnpj;
        }

        if (statusProtocolo) {
            params.statusProtocolo = statusProtocolo.codigo;
        }

        if (idProtocoloNegocio) {
            params.idProtocoloNegocio = idProtocoloNegocio;
        }

        if (idSolicitacaoApiExt) {
            params.idSolicitacaoApiExt = idSolicitacaoApiExt;
        }

        if (apenasValidacao !== undefined) {
            params.apenasValidacao = apenasValidacao;
        }

        if (dataEnvioInicial) {
            params.dataEnvioInicial = moment(dataEnvioInicial).format('YYYYMMDD');
        }

        if (dataEnvioFinal) {
            params.dataEnvioFinal = moment(dataEnvioFinal).format('YYYYMMDD');
        }

        if (this.incluirCampoJanelaEnvio && nomeJanelaEnvio) {
            const inicioJanela = moment(nomeJanelaEnvio).startOf('month').format('YYYYMMDD');
            const terminoJanela = moment(nomeJanelaEnvio).endOf('month').format('YYYYMMDD')
            if (!params.dataEnvioInicial) {
                params.dataEnvioInicial = inicioJanela;
            }
            if (!params.dataEnvioFinal) {
                params.dataEnvioFinal = terminoJanela;
            }
            // aplicando a restrição da janela
            if (params.dataEnvioInicial < inicioJanela) {
                params.dataEnvioInicial = inicioJanela;
            }
            if (params.dataEnvioFinal > terminoJanela) {
                params.dataEnvioFinal = terminoJanela;
            }
        }

        if (!['null', null].includes(tipoProtocolo)) {
            params.tiposProtocolos = tipoProtocolo;
        }
        else {
            params.tiposProtocolos = this.tiposConteudo.join('&');
        }

        if(voltarPagina1){
            this.atributosPaginacaoComponenteListagem.page = 1;
        }
        paginaVazia = Utils.verificaPaginaVazia(this.protocolos, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
            this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
        }
        params.pagina = this.atributosPaginacaoComponenteListagem.page;
        params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

        this.service.getArquivosPorAgente(params)
            .subscribe(response => {
                this.protocolos = response ? response.resultados : undefined;
                this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
                this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
                this.pesquisado = true;
                this.esconderPesquisa = false;
                this.cnpjSelecionado = agenteFinanceiro?.cnpj;
                this.loadingService.liberaTela();

                paginaVazia = Utils.verificaPaginaVazia(this.protocolos, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
                if (paginaVazia && !voltarPagina1) {
                    this.buscar(false, true);
                }
            }, err => this.loadingService.liberaTela());
    }

}
